import { XCircle } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  const handleTryAgain = () => {
    navigate("/premium");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <XCircle className="text-red-500 h-20 w-20 mb-4" />
      <h1 className="text-2xl font-bold mb-4">Pago Cancelado</h1>
      <p className="text-lg text-center mb-6">
        Has cancelado el proceso de pago. No te preocupes, no se ha realizado
        ningún cargo.
      </p>
      <div className="flex gap-4">
        <Button onClick={handleTryAgain} variant="default" className="mb-4">
          Intentar de Nuevo
        </Button>
        <Button
          onClick={handleGoToDashboard}
          variant="outline"
          className="mb-4"
        >
          Volver al Inicio
        </Button>
      </div>
      <p className="text-sm text-gray-500">
        Si tienes alguna pregunta, por favor contacta con nuestro soporte.
      </p>
    </div>
  );
};

export default PaymentCancel;
